import { getMyPendingOrdersApiCall, getOrderPaymentIntentApiCall } from '@guryou/api-client-gql';

import { execute } from '../actions/actionWrapper';
import { Action, basicReducer } from '../core';

export const PENDING_ORDERS_GET = { entity: 'PENDING_ORDERS', action: Action.GET_MANY };
export const ORDER_PAYMENT_INTENT_GET = { entity: 'ORDER_PAYMENT_INTENT', action: Action.GET };

export const getMyPendingOrders = () => async dispatch => execute(dispatch, () => getMyPendingOrdersApiCall(), PENDING_ORDERS_GET, false);
export const getOrderPaymentIntent = orderId => async dispatch =>
  execute(dispatch, () => getOrderPaymentIntentApiCall({ orderId }), ORDER_PAYMENT_INTENT_GET, false);

export const pendingOrdersFeelReducers = {
  list: basicReducer(PENDING_ORDERS_GET),
  orderPaymentIntent: basicReducer(ORDER_PAYMENT_INTENT_GET),
};
